/* =========================================
   DECANT SITUATION NOTE
========================================= */
export const productWearContext = {
  "Afnan 9 AM Eau de Parfum": {
    sr: "Svaki dan, posao i toplo vreme.",
    en: "Everyday wear, work and warm weather.",
  },
  "Afnan 9 PM Rebel Eau de Parfum": {
    sr: "Večernji izlazak, dejt i hladnije vreme.",
    en: "Nights out, date night and colder weather.",
  },
  "Afnan Supremacy Collector's Edition Pour Homme Eau de Parfum": {
    sr: "Posebne prilike, izlazak i snažan prepoznatljiv utisak.",
    en: "Special occasions, nights out and a strong signature impression.",
  },
  "Afnan Turathi Blue Homme Eau de Parfum": {
    sr: "Posao, svakodnevno nošenje i topli dani.",
    en: "Work, everyday wear and warm days.",
  },
  "Arabiyat Prestige Marwa Eau de Parfum": {
    sr: "Leto, svaki dan i čist sređen utisak.",
    en: "Summer, everyday wear and a clean polished impression.",
  },
  "Armaf Club de Nuit Bling Eau de Parfum": {
    sr: "Večernji izlazak, dejt i hladne noći.",
    en: "Nights out, date night and cold evenings.",
  },
  "Armaf Club de Nuit Intense Man Eau de Toilette": {
    sr: "Izlazak, posebne prilike i snažan prvi utisak.",
    en: "Nights out, special occasions and a strong first impression.",
  },
  "Armaf Club de Nuit Sillage Eau de Parfum": {
    sr: "Proleće, leto i upečatljivo dnevno nošenje.",
    en: "Spring, summer and distinctive daytime wear.",
  },
  "French Avenue Vulcan Sable Eau de Parfum": {
    sr: "Hladnije veče, dejt i poseban izlazak.",
    en: "Cool evenings, date night and special nights out.",
  },
  "Haramain Signature Blue Eau de Parfum": {
    sr: "Posao, svakodnevno nošenje i topli dani.",
    en: "Work, everyday wear and warm days.",
  },
  "Khadlaj Island Dreams Extrait de Parfum": {
    sr: "Leto, odmor i opušten dnevni izlazak.",
    en: "Summer, holidays and relaxed daytime outings.",
  },
  "Lattafa Asad Elixir Eau de Parfum": {
    sr: "Hladne večeri, dejt i noćni izlazak.",
    en: "Cold evenings, date night and nights out.",
  },
  "Lattafa Fakhar Black Eau de Parfum": {
    sr: "Svaki dan, posao i opušten večernji izlazak.",
    en: "Everyday wear, work and relaxed evenings out.",
  },
  "Lattafa Khamrah Qahwa Eau de Parfum": {
    sr: "Hladne noći, dejt i prijatni večernji trenuci.",
    en: "Cold nights, date night and cozy evening moments.",
  },
  "Lattafa Musamam Black Intense Eau de Parfum": {
    sr: "Posebne večeri, dejt i hladnije vreme.",
    en: "Special evenings, date night and colder weather.",
  },
  "Lattafa Qaed Al Fursan Untamed Eau de Parfum": {
    sr: "Izlazak, dejt i prilike kada želiš snažniji utisak.",
    en: "Nights out, date night and occasions that call for a stronger impression.",
  },
  "Paris Corner Emir Trillium Eau de Parfum": {
    sr: "Posao, leto i čisto svakodnevno nošenje.",
    en: "Work, summer and clean everyday wear.",
  },
  "Paris Corner Emir Voux Elegante Eau de Parfum": {
    sr: "Elegantne večeri, dejt i hladnije vreme.",
    en: "Elegant evenings, date night and colder weather.",
  },
  "Paris Corner Ministry of Oud Oud Satin Extrait de Parfum": {
    sr: "Svečane prilike, luksuzne večeri i hladne noći.",
    en: "Formal occasions, luxurious evenings and cold nights.",
  },
  "Paris Corner North Stag Expressions II Deux Extrait de Parfum": {
    sr: "Poseban izlazak, elegantno veče i hladnije vreme.",
    en: "Special nights out, elegant evenings and colder weather.",
  },
  "Rayhaan Aquatica Eau de Parfum": {
    sr: "Plaža, leto i najtopliji dnevni sati.",
    en: "The beach, summer and the hottest daytime hours.",
  },
  "Rayhaan Pacific Aura Eau de Parfum": {
    sr: "Leto, odmor i lagano svakodnevno nošenje.",
    en: "Summer, holidays and easy everyday wear.",
  },
  "Swiss Arabian Tobacco 01 Extrait de Parfum": {
    sr: "Hladne večeri, elegantan izlazak i posebne prilike.",
    en: "Cold evenings, elegant nights out and special occasions.",
  },
  "Acqua di Parma Blu Mediterraneo Fico di Amalfi Eau de Toilette": {
    sr: "Sunčani dani, odmor i opuštene letnje prilike.",
    en: "Sunny days, holidays and relaxed summer occasions.",
  },
  "Acqua di Parma Colonia Essenza Eau de Cologne": {
    sr: "Posao, elegantne dnevne prilike i toplo vreme.",
    en: "Work, elegant daytime occasions and warm weather.",
  },
  "Acqua di Parma Colonia Pura Eau de Cologne": {
    sr: "Topli dani, putovanja i opušteno svakodnevno nošenje.",
    en: "Warm days, travel and relaxed everyday wear.",
  },
  "Bleu de Chanel Eau de Parfum": {
    sr: "Posao, svaki dan i večernji izlazak.",
    en: "Work, everyday wear and evenings out.",
  },
  "Essential Parfums Bois Impérial Eau de Parfum": {
    sr: "Posao, gradski izlazak i prepoznatljivo celodnevno nošenje.",
    en: "Work, city outings and distinctive all-day wear.",
  },
  "BOSS Bottled Beyond Eau de Parfum": {
    sr: "Posao, dnevni sastanci i izlazak posle posla.",
    en: "Work, daytime meetings and after-work outings.",
  },
  "BOSS The Scent Elixir Parfum Intense for Him": {
    sr: "Dejt, noćni izlazak i hladnije vreme.",
    en: "Date night, nights out and colder weather.",
  },
  "BOSS The Scent Le Parfum for Him": {
    sr: "Intimno veče, dejt i elegantne prilike.",
    en: "Intimate evenings, date night and elegant occasions.",
  },
  "Calvin Klein CK All Eau de Toilette": {
    sr: "Leto, slobodno vreme i lagano svakodnevno nošenje.",
    en: "Summer, leisure time and easy everyday wear.",
  },
  "Calvin Klein Defy Eau de Toilette": {
    sr: "Posao, gradski dan i toplo vreme.",
    en: "Work, days in the city and warm weather.",
  },
  "Calvin Klein Defy Parfum": {
    sr: "Večernji izlazak, dejt i hladnije vreme.",
    en: "Evenings out, date night and colder weather.",
  },
  "Chopard Oud Malaki Eau de Parfum": {
    sr: "Svečane prilike, hladne večeri i elegantan izlazak.",
    en: "Formal occasions, cold evenings and elegant nights out.",
  },
  "Creed Aventus Cologne Eau de Parfum": {
    sr: "Posao, topli dani i sređene dnevne prilike.",
    en: "Work, warm days and polished daytime occasions.",
  },
  "Giorgio Armani Acqua di Giò Profondo Parfum": {
    sr: "Leto, posao i elegantne prilike pored mora.",
    en: "Summer, work and elegant seaside occasions.",
  },
  "Gisada Ambassador Men Eau de Parfum": {
    sr: "Noćni izlazak, dejt i prilike za upečatljiv utisak.",
    en: "Nights out, date night and occasions that call for a striking impression.",
  },
  "Givenchy Gentleman Réserve Privée Eau de Parfum": {
    sr: "Elegantno veče, dejt i hladnije vreme.",
    en: "Elegant evenings, date night and colder weather.",
  },
  "Jimmy Choo Man Blue Eau de Toilette": {
    sr: "Slobodno vreme, vikend i opušteni letnji dani.",
    en: "Leisure time, weekends and relaxed summer days.",
  },
  "Yves Saint Laurent L'Homme Eau de Parfum": {
    sr: "Dejt, elegantno svakodnevno nošenje i večernji izlazak.",
    en: "Date night, elegant everyday wear and evenings out.",
  },
  "L'Homme Idéal de Guerlain Paris Eau de Toilette": {
    sr: "Dejt, sređene dnevne prilike i opušteno veče.",
    en: "Date night, polished daytime occasions and relaxed evenings.",
  },
  "Mancera Cedrat Boise Eau de Parfum": {
    sr: "Svaki dan, putovanja i nošenje od jutra do večeri.",
    en: "Everyday wear, travel and easy transitions from morning to evening.",
  },
    "Montblanc Explorer Extreme Parfum": {
    sr: "Hladnije vreme, večernji izlazak i posebne prilike.",
    en: "Colder weather, evenings out and special occasions.",
  },
  "Narciso Rodriguez for Him Bleu Noir Eau de Parfum": {
    sr: "Posao, svaki dan i nenametljive večernje prilike.",
    en: "Work, everyday wear and understated evening occasions.",
  },
  "Terre d'Hermès Eau de Toilette": {
    sr: "Posao, topli dani i elegantne dnevne prilike.",
    en: "Work, warm days and elegant daytime occasions.",
  },
  "Tom Ford Noir Extreme Eau de Parfum": {
    sr: "Posebno veče, dejt i hladnije vreme.",
    en: "Special evenings, date night and colder weather.",
  },
  "Afnan 9PM Night Out Extrait de Parfum": {
    sr: "Noćni izlazak, dejt i hladne večeri.",
    en: "Nights out, date night and cold evenings.",
  },
  "Rasasi Hawas Ice for Him Eau de Parfum": {
    sr: "Leto, dnevni izlazak i visoke temperature.",
    en: "Summer, daytime outings and hot weather.",
  },
  "Armaf Club de Nuit Precieux 1 Extrait de Parfum": {
    sr: "Posebne prilike, večernji izlazak i snažan utisak.",
    en: "Special occasions, evenings out and a strong impression.",
  },
  "French Avenue Safari Breeze Eau de Parfum": {
    sr: "Leto, odmor i opušteni dani na otvorenom.",
    en: "Summer, holidays and relaxed days outdoors.",
  },
  "Lattafa Dynasty Eau de Parfum": {
    sr: "Izlazak, posebne prilike i prepoznatljivo celodnevno nošenje.",
    en: "Nights out, special occasions and distinctive all-day wear.",
  },
  "Dolce&Gabbana The One for Men Eau de Toilette": {
    sr: "Dejt, intimno veče i elegantan izlazak.",
    en: "Date night, intimate evenings and elegant nights out.",
  },
  "Versace Man Eau Fraîche Eau de Toilette": {
    sr: "Leto, odmor i lagano svakodnevno nošenje.",
    en: "Summer, holidays and easy everyday wear.",
  },
  "Paris Corner Emir Voux Zingy Eau de Parfum": {
    sr: "Topli dani, posao i energičan dnevni izlazak.",
    en: "Warm days, work and energetic daytime outings.",
  },
  "Rayhaan Crimson Eau de Parfum": {
    sr: "Hladne večeri, dejt i noćni izlazak.",
    en: "Cold evenings, date night and nights out.",
  },
  "Rasasi Hawas Black Eau de Parfum": {
    sr: "Izlazak, dejt i prilike kada želiš upečatljiv utisak.",
    en: "Nights out, date night and occasions that call for a striking impression.",
  },
  "Khadlaj Onyx Silver Eau de Parfum": {
    sr: "Posao, svakodnevno nošenje i opušten večernji izlazak.",
    en: "Work, everyday wear and relaxed evenings out.",
  },
  "Arabiyat Prestige Fahad Gaze Eau de Parfum": {
    sr: "Elegantne večeri, dejt i hladnije vreme.",
    en: "Elegant evenings, date night and colder weather.",
  },
  "Narciso Rodriguez NARCISO Poudrée Eau de Parfum": {
    sr: "Elegantno svakodnevno nošenje, posebne prilike i mirne večeri.",
    en: "Elegant everyday wear, special occasions and quiet evenings.",
  },
  "Yves Saint Laurent Black Opium Le Parfum": {
    sr: "Dejt, noćni izlazak i hladne večeri.",
    en: "Date night, nights out and cold evenings.",
  },
  "French Avenue Pinnace Oryn Eau de Parfum": {
    sr: "Leto, posao i čisto svakodnevno nošenje.",
    en: "Summer, work and clean everyday wear.",
  },
  "RiiFFS Freeze Extrait de Parfum": {
    sr: "Plaža, leto i dnevni izlazak.",
    en: "The beach, summer and daytime outings.",
  },
  "Lattafa Maahir Legacy Eau de Parfum": {
    sr: "Posao, leto i svakodnevno nošenje.",
    en: "Work, summer and everyday wear.",
  },
  "Yves Saint Laurent Y Iced Cologne Eau de Toilette Intense": {
    sr: "Leto, dnevno nošenje i visoke temperature.",
    en: "Summer, daytime wear and hot weather.",
  },
  "Valentino Uomo Born in Roma Coral Fantasy Eau de Toilette": {
    sr: "Dejt, večernji izlazak i posebne prilike.",
    en: "Date night, evenings out and special occasions.",
  },
  "Dolce&Gabbana Light Blue Pour Homme Eau de Toilette (2025)": {
    sr: "Leto, more i svakodnevno nošenje.",
    en: "Summer, the seaside and everyday wear.",
  },
  "BVLGARI Man in Black Eau de Parfum": {
    sr: "Hladnije vreme, dejt i elegantan večernji izlazak.",
    en: "Colder weather, date night and elegant evenings out.",
  },
  "Mancera Aoud Lemon Mint Eau de Parfum": {
    sr: "Topli dani, izlazak i prilike za upečatljiv utisak.",
    en: "Warm days, nights out and occasions that call for a striking impression.",
  },
  "Prada Paradigme Eau de Parfum": {
    sr: "Posao, izlazak i prepoznatljivo celodnevno nošenje.",
    en: "Work, evenings out and distinctive all-day wear.",
  },
  "Yves Saint Laurent MYSLF Eau de Parfum": {
    sr: "Svaki dan, posao i večernji izlazak.",
    en: "Everyday wear, work and evenings out.",
  },
  "Carolina Herrera Bad Boy Cobalt Eau de Parfum Électrique": {
    sr: "Izlazak, dejt i moderan svakodnevni stil.",
    en: "Nights out, date night and modern everyday wear.",
  },
  "Prada Luna Rossa Ocean Eau de Toilette": {
    sr: "Leto, posao i čisto dnevno nošenje.",
    en: "Summer, work and clean daytime wear.",
  },
  "Thomas Kosmala No. 7 Le Sel de la Terre Eau de Parfum": {
    sr: "Leto, more i upečatljivo svakodnevno nošenje.",
    en: "Summer, the seaside and distinctive everyday wear.",
  },
  "Jean Paul Gaultier Le Beau Eau de Toilette": {
    sr: "Leto, dejt i večernji izlazak.",
    en: "Summer, date night and evenings out.",
  },
  "Rayhaan Azul Eau de Parfum": {
    sr: "Posao, leto i svakodnevno nošenje.",
    en: "Work, summer and everyday wear.",
  },
  "Lattafa Suqraat Eau de Parfum": {
    sr: "Leto, more i dnevno nošenje.",
    en: "Summer, the seaside and daytime wear.",
  },
  "Khadlaj Shiyaaka Snow Eau de Parfum": {
    sr: "Posao, elegantne dnevne prilike i toplo vreme.",
    en: "Work, elegant daytime occasions and warm weather.",
  },
  "French Avenue Ravine Ginger Extrait de Parfum": {
    sr: "Letnji izlazak, posebne prilike i upečatljivo večernje nošenje.",
    en: "Summer nights out, special occasions and distinctive evening wear.",
  },
  "Lattafa Khamrah Waha Eau de Parfum": {
    sr: "Topli dani, dejt i opušten večernji izlazak.",
    en: "Warm days, date night and relaxed evenings out.",
  },
  "Rayhaan Nocturno Elixir Eau de Parfum": {
    sr: "Posao, svakodnevno nošenje i večernji izlazak.",
    en: "Work, everyday wear and evenings out.",
  },
  "French Avenue Ravine Ice Extrait de Parfum": {
    sr: "More, leto i dnevno nošenje.",
    en: "The seaside, summer and daytime wear.",
  },
  "Paris Corner Mawj Moscow Mule Eau de Parfum": {
    sr: "Leto, dnevni izlazak i najveće vrućine.",
    en: "Summer, daytime outings and the hottest weather.",
  },
  "My Geisha Jasmine in the Sun Extrait de Parfum": {
    sr: "Leto, svakodnevno nošenje i elegantne dnevne prilike.",
    en: "Summer, everyday wear and elegant daytime occasions.",
  },
  "Essential Parfums Nice Bergamote Eau de Parfum": {
    sr: "Topli dani, posao i svakodnevno nošenje.",
    en: "Warm days, work and everyday wear.",
  },
  "Essential Parfums Orange X Santal Eau de Parfum": {
    sr: "Posao, svaki dan i opuštene večernje prilike.",
    en: "Work, everyday wear and relaxed evening occasions.",
  },
  "Armaf Club de Nuit Intense Overdose Eau de Parfum": {
    sr: "Izlazak, veče, posebne prilike.",
    en: "Going out, evenings, special occasions."
  },
  "Gisada Luxury Collection Royal Parfum": {
    sr: "Veče, posebne prilike, elegantan izlazak.",
    en: "Evening, special occasions, elegant outings."
  },
  "Swiss Arabian Musk 01 Extrait de Parfum": {
    sr: "Svaki dan, posao, elegantne prilike.",
    en: "Everyday wear, work, elegant occasions."
  },
  "Afnan Turathi Electric Eau de Parfum": {
    sr: "Leto, posao, svakodnevno nošenje.",
    en: "Summer, work, everyday wear."
  },
  "Jil Sander Sun Eau de Toilette": {
    sr: "Topli dani, odmor, opuštene prilike.",
    en: "Warm days, holidays, relaxed occasions."
  },
  "Mancera Cosmic Pepper Eau de Parfum": {
    sr: "Izlazak, veče, upečatljivo svakodnevno nošenje.",
    en: "Going out, evenings, bold everyday wear."
  },
  "Thomas Kosmala No. 4 Après l'Amour Eau de Parfum": {
    sr: "Izlazak, dejt, svakodnevno nošenje.",
    en: "Going out, date night, everyday wear."
  },
  "Thomas Kosmala No. 1 Tonic Blanc Eau de Parfum": {
    sr: "Leto, posao, dnevno nošenje.",
    en: "Summer, work, daytime wear."
  },
  "Narciso Rodriguez for Him Bleu Noir Eau de Toilette Extreme": {
    sr: "Topli dani, posao, svakodnevno nošenje.",
    en: "Warm days, work, everyday wear."
  },

  "Thomas Kosmala No. 8 Tonic Vert Eau de Parfum": {
    sr: "Topli dani, posao, svakodnevno nošenje.",
    en: "Warm days, work, everyday wear."
  },

  "Christian Dior Sauvage Eau de Parfum": {
    "sr": "Cijele godine; posao, grad, dejt i veče.",
    "en": "Year-round; work, city, dates and evenings."
  },

  "Nishane Hacivat X Extrait de Parfum": {
    "sr": "Proleće do jeseni; grad, posao, večernji izlazak.",
    "en": "Spring through autumn; city, work and evening wear."
  },

  "Yves Saint Laurent La Nuit de L'Homme Eau de Toilette": {
    "sr": "Najbolji uveče i po hladnijem vremenu; idealan za dejt.",
    "en": "Best at night and in cooler weather; ideal for dates."
  },

  "Tom Ford Ombré Leather Parfum": {
    "sr": "Najbolji uveče i po hladnijem vremenu; odličan za dejt.",
    "en": "Best at night and in cooler weather; excellent for dates."
  },

  "Arabiyat Prestige Al Noor Eau De Parfum": {
    "sr": "Hladnije vreme, veče i izlazak. U kancelariji umerenije.",
    "en": "Cooler weather, evenings and nights out. Go easy at the office."
  },

  "Rayhaan Elixir Eau de Parfum": {
    "sr": "Veče, izlazak, dejt i hladniji dani.",
    "en": "Evenings, dates, nights out and cooler weather."
  },

  "Jil Sander Sun Men Eau de Toilette": {
    "sr": "Topli dani, posao, odmor i opuštene dnevne prilike.",
    "en": "Warm days, work, holidays and relaxed daytime wear."
  },

  "My Geisha Unseen Extrait de Parfum": {
    "sr": "Hladnije vreme, dejt, veče i posebne prilike.",
    "en": "Cooler weather, dates, evenings and special occasions."
  },

  "Nishane Hundred Silent Ways X Extrait de Parfum": {
    "sr": "Veče, dejt i elegantne prilike u hladnijem delu godine.",
    "en": "Evenings, dates and dressed-up occasions in cooler weather."
  },

  "French Avenue Spectre Ghost Eau de Parfum": {
    "sr": "Jesen, zima, dejt i večernji izlazak.",
    "en": "Autumn, winter, dates and evenings out."
  },

  "Maison Alhambra Jean Lowe Verde Aura Eau de Parfum": {
    "sr": "Proleće, leto, posao, šetnja i opušteni dnevni planovi.",
    "en": "Spring, summer, work, walks and easy daytime plans."
  },

  "French Avenue Imperial Ocean Eau de Parfum": {
    "sr": "Leto, proleće, posao, more i opuštene dnevne prilike.",
    "en": "Summer, spring, work, seaside days and casual outings."
  },

  "Armaf Club de Nuit Milestone Eau de Parfum": {
    "sr": "Proleće, leto, more, posao i elegantne dnevne prilike.",
    "en": "Spring, summer, seaside, work and elegant daytime wear."
  },

  "Armaf Club de Nuit Maleka Eau de Parfum": {
    "sr": "Proleće, jesen, dejt, svečani ručak i elegantno veče.",
    "en": "Spring, autumn, dates, special lunches and elegant evenings."
  },

  "Giorgio Armani I Will Eau de Parfum": {
    "sr": "Posao, večernji izlazak, dejt i hladniji dani.",
    "en": "Work, evenings, dates and cooler days."
  },

  "Bujairami Too Damn Good Extrait de Parfum": {
    "sr": "Svakodnevno, za dejt, grad i prijatne večeri.",
    "en": "Everyday wear, dates, city outings and relaxed evenings."
  },

  "Bujairami Hectic Extrait de Parfum": {
    "sr": "Posao, putovanja, leto, svakodnevno i gradske šetnje.",
    "en": "Work, travel, summer, everyday wear and city walks."
  }
};